import React from 'react'

import { Alert } from '@material-ui/lab'

import constants from 'constants/index'
import useStyles from './styles'

const AlertSendToSegcoop = ({ status }) => {
  const classes = useStyles()
  const severity =
    constants.governanceProject.SEGCOOP_STATUS_SEVERITY[status] || 'info'
  const text =
    constants.governanceProject.SEGCOOP_DIALOG_TEXT[status]?.description
  return (
    <Alert
      className={classes.alertSegcoop}
      variant={status === 'pending' ? 'standard' : 'filled'}
      severity={severity}
    >
      {text}
    </Alert>
  )
}

export default AlertSendToSegcoop
